import { Navigate, Routes, Route } from "react-router-dom";
import DashboardLayout from "./components/DashboardLayout";
import PermissionRoute from "./components/PermissionRoute";
import ProtectedRoute from "./components/ProtectedRoute";
import { ApplicationsProvider } from "./context/ApplicationsContext";
import ApplicationChat from "./pages/ApplicationChat";
import Dashboard from "./pages/Dashboard";
import Home from "./pages/Home";
import Login from "./pages/Login";
import ManageApplications from "./pages/ManageApplications";
import ManageUsers from "./pages/ManageUsers";
import NotFound from "./pages/NotFound";
import ResetPassword from "./pages/ResetPassword";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />

      <Route element={<ProtectedRoute />}>
        <Route
          path="/dashboard"
          element={
            <ApplicationsProvider>
              <DashboardLayout />
            </ApplicationsProvider>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="applications/:applicationId" element={<ApplicationChat />} />
          <Route path="settings/password" element={<ResetPassword />} />

          <Route element={<PermissionRoute permission="can_manage_users" />}>
            <Route path="manage/users" element={<ManageUsers />} />
          </Route>

          <Route element={<PermissionRoute permission="can_manage_applications" />}>
            <Route path="manage/applications" element={<ManageApplications />} />
          </Route>

          {/* Where the password page used to live. */}
          <Route path="reset-password" element={<Navigate to="/dashboard/settings/password" replace />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
